var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_3261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91326 10.2574C-0.971087 14.1876 -0.971087 20.5501 2.91326 24.4803L12.6606 34.3426C16.5578 38.2858 22.8863 38.2858 26.7835 34.3426L33.812 27.2311L17.0362 10.2574C13.139 6.31418 6.81049 6.31418 2.91326 10.2574ZM14.1912 13.0692L28.187 27.231L23.9385 31.5308C21.6071 33.8897 17.8369 33.8897 15.5055 31.5308L5.75823 21.6685C3.41392 19.2965 3.41392 15.4412 5.75823 13.0692C8.08965 10.7103 11.8598 10.7103 14.1912 13.0692Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0887 10.2574C48.973 14.1876 48.973 20.5501 45.0887 24.4803L35.3414 34.3426C31.4442 38.2858 25.1157 38.2858 21.2185 34.3426L14.19 27.2311L30.9657 10.2574C34.863 6.31418 41.1915 6.31418 45.0887 10.2574ZM33.8107 13.0692L19.815 27.231L24.0634 31.5308C26.3948 33.8897 30.165 33.8897 32.4964 31.5308L42.2437 21.6685C44.588 19.2965 44.588 15.4412 42.2437 13.0692C39.9123 10.7103 36.1421 10.7103 33.8107 13.0692Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2H36C38.2091 2 40 3.79086 40 6V23C40 31.8366 32.8366 39 24 39C15.1634 39 8 31.8366 8 23V6C8 3.79086 9.79086 2 12 2Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27C27.866 27 31 23.866 31 20C31 16.134 27.866 13 24 13C20.134 13 17 16.134 17 20C17 23.866 20.134 27 24 27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 42H16C14.8954 42 14 42.8954 14 44C14 45.1046 14.8954 46 16 46H32C33.1046 46 34 45.1046 34 44C34 42.8954 33.1046 42 32 42Z",
    fill: "#F47B04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_3261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup48);
export default __webpack_public_path__ + "static/media/cup48.cbe8e2fb90202df1b5ffd7fac588a4e8.svg";
export { ForwardRef as ReactComponent };